import Role from "./Role";

export type DetailedUserInfo = {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    companyId: string;
    companyDepartmentId: number | undefined;
    roles: Role[];
    receivesSms: boolean;
    canEditPassword: boolean;
}

export function DetailedUserInfo_normalize(detailedUserInfo: DetailedUserInfo): DetailedUserInfo {
    return {
        id: detailedUserInfo.id ?? "",
        companyDepartmentId: detailedUserInfo.companyDepartmentId,
        companyId: detailedUserInfo.companyId ?? "",
        email: detailedUserInfo.email ?? "",
        firstName: detailedUserInfo.firstName ?? "",
        lastName: detailedUserInfo.lastName ?? "",
        phoneNumber: detailedUserInfo.phoneNumber ?? "",
        roles: detailedUserInfo.roles?.map(r => ({
            departmentId: r.departmentId ?? 0,
            departmentName: r.departmentName ?? "",
            name: r.name ?? "",
            roleCode: r.roleCode ?? "",
            canRemoveUserFromRole: r.canRemoveUserFromRole ?? false
        })) ?? [],
        receivesSms: detailedUserInfo.receivesSms ?? false,
        canEditPassword: detailedUserInfo.canEditPassword ?? false
    }
}